/* istanbul ignore file */
import * as checker from './checker/index.js';
import { registerMcdocAttributes } from './mcdocAttributes.js';
export const initialize = (ctx) => {
    registerMcdocAttributes(ctx.meta);
    checker.register(ctx.meta);
};
//# sourceMappingURL=index.js.map